/*globals jQuery */

jQuery(function () {
    var ugent = {};    /*  setup namespace */

    // Restore old implementation on doctoraat-toevoegen (PCM-1129)
    if (jQuery('.easyformForm.formid-doctoraat-toevoegen').length) {
        ugent.filter_dropdowns = function () {
            var fac, findstr, start;
            fac = jQuery('.easyformForm select#faculteit').val();
            if (fac === "RE") {
                start = "21";
            } else if (fac === "DI") {
                start = "02";
            } else if (fac === "DS") {
                start = "10"
            } else {
                start = "01";
            }
            findstr = "option[value^=" + fac + start + "]";
            jQuery('.easyformForm select#vakgroep')
                .find(findstr)
                .attr('selected', 'selected');
            jQuery('.selectpicker').selectpicker('refresh');
        };

        jQuery('.easyformForm select#vakgroep').prepend('<option value="" selected="selected">Niet van toepassing</option>');
            ugent.filter_dropdowns();

        jQuery('.easyformForm select#faculteit').change(function () {
            ugent.filter_dropdowns();
        });
    } else {    
        var originalState = jQuery(".easyformForm select#vakgroep").clone();

        ugent.filter_dropdowns = function () {
            var fac = jQuery('.easyformForm select#faculteit').val();
            jQuery('.easyformForm select#vakgroep option')
                .filter(function() {
                    var dep = jQuery(this).val();
                    if (dep.indexOf(fac) !== -1) {
                        return false;
                    } else {
                        return true;
                    }
                }).remove();
        };

        ugent.filter_dropdowns();
        jQuery('.easyformForm select#vakgroep').prepend('<option value="" selected="selected">Niet van toepassing</option>');

        jQuery('.easyformForm select#faculteit').change(function () {
            jQuery(".easyformForm select#vakgroep").replaceWith(originalState.clone());
            jQuery('#archetypes-fieldname-vakgroep').find('.bootstrap-select').replaceWith(function() { return jQuery('select', this); }) // remove bootstrap-select
            ugent.filter_dropdowns();
            jQuery('.easyformForm select#vakgroep').prepend('<option value="" selected="selected">Niet van toepassing</option>');
            jQuery('#archetypes-fieldname-vakgroep').find('select').selectpicker(); // restore bootstrap-select
        });

    }
});


